import { render } from "./plagiarismIcon.vue?vue&type=template&id=1cf51075&scoped=true"
import script from "./plagiarismIcon.vue?vue&type=script&lang=js"
export * from "./plagiarismIcon.vue?vue&type=script&lang=js"

import "./plagiarismIcon.vue?vue&type=style&index=0&id=1cf51075&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf51075"]])

export default __exports__